var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 381,
    height: 381,
    viewBox: "0 0 381 381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WhatsApp_",
    "data-name": "WhatsApp ",
    transform: "translate(-0.29)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16751",
    "data-name": "Ellipse 16751",
    cx: 190.5,
    cy: 190.5,
    r: 190.5,
    transform: "translate(0.29)",
    fill: "#415993"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_269860",
    "data-name": "Group 269860",
    transform: "translate(85.256 85.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497484",
    "data-name": "Path 497484",
    d: "M86.038,40.384h33.654V0H86.038A47.167,47.167,0,0,0,38.923,47.115V67.307H12v40.384H38.923V215.383H79.307V107.692h33.654l6.731-40.384H79.307V47.115A6.839,6.839,0,0,1,86.038,40.384Z",
    transform: "translate(41.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497485",
    "data-name": "Path 497485",
    d: "M0,0H215.383V215.383H0Z",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.63a27d8da82c9113608b3fd2617dd50c.svg";
export { ForwardRef as ReactComponent };